var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('cloudenv.text_11')}}),_c('page-body',[_c('zone-list',{attrs:{"getParams":_vm.getParams,"id":_vm.listId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }